document.querySelector(".preloader").style.opacity = "0";